import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../../redux';
import { IReadyBusinessGroupItem } from '../../../../../repositories/announcements/entities/AnnouncementReferences/ReadyBusinessGroupItem';
import { businessAppointmentsDataSelector } from '../../../../../selectors/business/businessAppointmentsDataSelector';
import { filterReadyBusinessTypesSelector } from '../../../../../selectors/business/filterReadyBusinessTypesSelector';
import { TBusinessAppointmentsState } from '../../../../../types/businessType';
import { getIsBusinessCategory } from '../helpers/getIsBusinessCategory';

export function useBusinessAppointmentsDataSelector(): Array<IReadyBusinessGroupItem> {
  const businessAppointments = useSelector<IAppState, TBusinessAppointmentsState['data']>(
    businessAppointmentsDataSelector,
  );

  const readyBusinessType = useSelector(filterReadyBusinessTypesSelector);

  return useMemo(() => {
    const groups = Array.of<IReadyBusinessGroupItem>();

    if (!businessAppointments) {
      return groups;
    }

    const { isRentalBusiness, isReadyBusiness } = getIsBusinessCategory(readyBusinessType);

    if (isRentalBusiness) {
      groups.push({
        groupType: 'rentalBusiness',
        items: businessAppointments.rentalBusiness.items,
        name: 'Арендный бизнес',
      });
    }

    if (isReadyBusiness) {
      groups.push(...businessAppointments.readyBusiness.groups);
    }

    return groups;
  }, [businessAppointments, readyBusinessType]);
}
